import { useEffect, useState } from "react";
// Reusable component
import InputText from "../ReusableComponents/InputText";
import Buttons from "../components/Buttons";
import GridPage from "../components/GridPage";
import { holidayMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import PopUpButtons from "../components/PopUpButtons";
import AddScreenTitle from "../components/AddScreenTitle";
import HolidayPopup from "../popup-containers/Holidaypopup";
// API and Utilities
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import { format } from "date-fns";
import Loader from "../ReusableComponents/Loader";
import TextArea from "../ReusableComponents/TextArea";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const Holidaymaster = () => {
  // UI visibility states
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
      const [isOpen, setIsOpen] = useState(false);
  const createdBy = sessionStorage.getItem("createdBy");
  const clientId = sessionStorage.getItem("MstClientId");
  // Submission and loading control states
  const [isLoading, setIsLoading] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  // Popup states
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  // Form and validation states
  const [formFields, setFormFields] = useState({
    holiday: "",
    date: "",
    day: "",
    description: "",
  });
  const [errors, setErrors] = useState({
    holiday: "",
    date: "",
    day: "",
    description: "",
  });
  // Identifier and record context
  const [mstHolidayId, setMstHolidayId] = useState("");
  const [rowIndex, setRowIndex] = useState(null);
  // Data states
  const [holidayData, setHolidayData] = useState({});
  // Main grid data
  const [bindholidayMasterData, setBindholidayMasterData] = useState([]);
  // Fetch data initially on mount
  useEffect(() => {
    bindHolidayMaster();
  }, []);
  // API call to bind Holiday Master data
  const bindHolidayMaster = async () => {
    try {
      const data = {
        mstClientId: clientId,
      };
      setIsLoading(true); //  Start loader
      const response = await BindPostAPI(
        data,
        "HolidayMasterAPI/bindHolidayMaster"
      );
      setBindholidayMasterData(response.data?.Table || []);
      // console.log("📊 bindholidayMasterData:", bindholidayMasterData);
    } catch (error) {
      console.error("Error while binding Holiday Master:", error);
    } finally {
      setIsLoading(false); //  Always stop loader
    }
  };

  // Handle editing a row
  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstHolidayId(bindholidayMasterData[rowIndex].MstHolidayId);
   const formatted = bindholidayMasterData[rowIndex]?.Date
  ? format(new Date(bindholidayMasterData[rowIndex].Date), "yyyy-MM-dd")
  : "";
    setFormFields({
      ...formFields,
      date: formatted,
      day: bindholidayMasterData[rowIndex].Day,
      holiday: bindholidayMasterData[rowIndex].Holiday,
      description: bindholidayMasterData[rowIndex].Description,
    });
  };
  // Handle different popup actions (View/Delete/Block/Unblock)
  const handleState = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
    setHolidayData(bindholidayMasterData[rowIndex]);
  };
  // Validate form fields on blur
  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (value.trim() === "") {
      const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
      error = `Enter ${formattedName} `;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };
  // Validate individual field and set error
  const validateField = (fieldName, value) => {
    let error = "";

    if (!value || !value.trim()) {
      const formattedName =
        fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
      error = `Enter ${formattedName} .`;
    } else {
      // ✅ Additional validation for holiday field only
      if (fieldName === "holiday") {
        const isValid = /^[A-Za-z ]{3,30}$/.test(value);
        if (!isValid) {
          error = "Enter a valid Holiday Name";
        }
      }
    }

    setErrors((prev) => ({ ...prev, [fieldName]: error }));
    return error === ""; // ✅ true = valid, ❌ false = invalid
  };

  // Show add form with default date
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setFormFields({
      ...formFields,
      // date: formattedDate,
      date:''
      
    });
  };
  // Cancel and reset views
  const cancel = () => {
    bindHolidayMaster();
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setIsLoading(false);
    setpopUpOpen(false);
    setFormFields({ holiday: "", date: "", day: "", description: "" });
    setErrors({ holiday: "", date: "" });
  };

  // Handle input field change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // Submit form data (Insert/Update/Delete/Block/Unblock)
const handleSubmit = async (rowIndex, flag) => {
  
  if (submitBtnDisabled) return; // Prevent multiple clicks
  setSubmitBtnDisabled(true);    // Disable immediately

  if (flag === 1 || flag === 2) {
    const isHolidayValid = validateField("holiday", formFields.holiday);
const isDateValid = validateField("date", formFields.date);
;

    if (!isHolidayValid || !isDateValid ) {
      setIsOpen(true);              
      setSubmitBtnDisabled(false); // Re-enable on validation error
      return;
    }

    setIsLoading(true);

    const data = {
      mstClientId: parseInt(clientId),
      mstHolidayId: mstHolidayId ? mstHolidayId : 0,
      date: formFields.date,
      day: formFields.day,
      holiday: formFields.holiday,
      description: formFields.description,
      createdBy: parseInt(createdBy),
      flag: flag,
    };

    const response = await IUDAPI([data], "HolidayMasterAPI/IUDHolidayMaster");
    const result = response?.data?.Table?.[0]?.Result;

    if (flag === 1 && result === "S") {
      toast.success("Holiday Master data inserted successfully! 👍");
    } else if (flag === 2 && result === "M") {
      toast.success("Holiday Master data modified successfully! 👍");
    } else {
      toast.error("Insert/Update failed 👎");
    }

    setIsLoading(false);
    setSubmitBtnDisabled(false); // ✅ Re-enable after API call
    cancel();
  } else {
    const data = {
      mstClientId: parseInt(clientId),
      mstHolidayId: bindholidayMasterData?.[rowIndex]?.MstHolidayId ?? 0,
      createdBy: parseInt(createdBy),
      flag: flag,
    };

    const response = await IUDAPI([data], "HolidayMasterAPI/IUDHolidayMaster");
    const result = response?.data?.Table?.[0]?.Result;

    if (flag === 3 && result === "D") {
      toast.success("HolidayMaster data deleted successfully! 👍");
    } else if (flag === 4 && result === "B") {
      toast.success("HolidayMaster data Inactivated successfully! 👍");
    } else if (flag === 5 && result === "UB") {
      toast.success("HolidayMaster data activated successfully! 👍");
    } else {
      toast.error("Action failed 👎");
    }

    setSubmitBtnDisabled(false); // ✅ Re-enable after API call
    cancel();
  }
};


// Cancel function
// const cancel = () => {
//   // Reset your form here
//   setSubmitBtnDisabled(false); // ✅ Enable only after close/reset
// };



  return (
    <>
      <MainLayout pageName="2">
        <Loader
          isVisible={isLoading}
          size="h-20 w-20"
          color="border-t-black"
          blur={true}
        />
        {visibleTable && (
          //Grid view section
          <GridPage
            title={"Holidays"}
            header={holidayMasterHeader}
            records={bindholidayMasterData}
            handleEdit={handleEdit}
            handleAction={handleState}
            showAdd={showAdd}
            blockView={true}
          />
        )}

        {visibleAdd && (
          // Add or Update form section
          <>
            <AddScreenTitle
              title={"Holidays"}
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
              <InputText
                inputType="date"
                title="Date"
                name="date"
                classStar="text-red-500"
                label="Date"
                content={formFields.date}
                controlFunc={(e) => {
                  const selectedDate = e.target.value;
                  const dayString = new Date(selectedDate).toLocaleDateString(
                    "en-US",
                    {
                      weekday: "long",
                    }
                  );

                  setFormFields((prev) => ({
                    ...prev,
                    date: selectedDate,
                    day: dayString, // auto update
                  }));
                  
                }}
                controlFuncBlur={(e) => validateField("date", e.target.value)}
                errorMessage={errors.date}
              />

              <InputText
                inputType="text"
                title="Day"
                name="day"
                classStar="text-red-500"
                maxLength={100}
                content={formFields.day}
                controlFunc={handleInputChange}
                controlFuncBlur={(e) =>
                  validateField("holiday", e.target.value)
                }
                errorMessage={errors.day}
                disabled={true}
              />
              <InputText
                inputType="text"
                title="Holiday"
                name="holiday"
                classStar="text-red-500"
                maxLength={100}
                content={formFields.holiday}
                controlFunc={handleInputChange}
                controlFuncBlur={(e) =>
                  validateField("holiday", e.target.value)
                }
                errorMessage={errors.holiday}
                disabled={false}
              />
            </div>
            <div className="p-4">
              <TextArea
                title="Description"
                rows={3}
                name="description"
                content={formFields.description}
                resize={false}
                placeholder="Enter description"
                controlFunc={(e) =>
                  setFormFields((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                controlFuncBlur={() => {}}
                disabled={false}
                // tabIndex="0"
                errorMessage={errors.description}
              />
            </div>
            <div className="flex justify-center mt-[100px]">
              <Buttons
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                handleSubmit={handleSubmit}
                cancel={cancel}
                disabledBtn={false}
                viewSaveButton={false}
              />
            </div>
            {/* </form>
                  </div>
                </div>
              </div>
            </div> */}
          </>
        )}
             {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
        <MainPopup
          popUpOpen={popUpOpen}
          setpopUpOpen={setpopUpOpen}
          Open={handleState}
        >
          <div>
            <PopUpScreenTitle
              title="Holiday"
              setpopUpOpen={setpopUpOpen}
              viewDetails={viewDetails}
              deleteDetails={deleteDetails}
              blockDetails={blockDetails}
              unBlockDetails={unBlockDetails}
            />
            <HolidayPopup data={holidayData} />
          </div>

          <PopUpButtons
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
            rowIndex={rowIndex}
            handleSubmit={handleSubmit}
            cancel={cancel}
            disabledBtn={submitBtnDisabled ? true : false}
          />
        </MainPopup>
      </MainLayout>
    </>
  );
};

export default Holidaymaster;
